import { render, staticRenderFns } from "./SearchFacets.vue?vue&type=template&id=5456c7cd&lang=pug&"
import script from "./SearchFacets.vue?vue&type=script&lang=js&"
export * from "./SearchFacets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports